import React from 'react';
import styled from 'styled-components';


const Container = styled.div`
padding-top:10px;
display:grid;
grid-template-columns:154px 154px 269px 159px 174px;
padding-left:10px;
padding-right:10px;
padding-bottom:10px;
`; 

const ItemText = styled.div`
color: black;
font-family: Roboto;
font-size: 14px;
font-weight: 100;
line-height: 19px;
text-align: left;
`;

const hyphenIfNull = text => text ? text : '-'; 

const UserRolesListItem = ({role}) => (
   < Container>
    <ItemText>{hyphenIfNull(role.name)}</ItemText>
    <ItemText>{hyphenIfNull(role.scope)}</ItemText>
    <ItemText>{hyphenIfNull(role.project)}</ItemText>
    <ItemText>{hyphenIfNull(role.gbu)}</ItemText>
    <ItemText>{hyphenIfNull(role.function)}</ItemText>
   </Container>
)

export default UserRolesListItem;